var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    style: {
      "marginRight": 2,
      "marginTop": "-2px"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillrule: "evenodd",
    cliprule: "evenodd",
    d: "M15.391 4.938C14.989 3.968 14.4 3.085 13.657 2.343C12.915 1.6 12.032 1.011 11.062 0.609C10.091 0.206 9.05104 0 8.00004 0C6.41804 0 4.87104 0.469 3.55504 1.348C2.24004 2.227 1.21504 3.477 0.609037 4.938C0.00303715 6.4 -0.154963 8.009 0.154037 9.561C0.463037 11.113 1.22404 12.539 2.34404 13.657C3.46304 14.776 4.88804 15.538 6.44004 15.847C7.99204 16.155 9.60104 15.997 11.062 15.391C12.524 14.785 13.773 13.761 14.652 12.445C15.531 11.129 16 9.582 16 8C16 6.95 15.793 5.909 15.391 4.938ZM12.526 12.526C11.325 13.726 9.69804 14.4 8.00004 14.4C6.73404 14.4 5.49704 14.024 4.44504 13.321C3.39204 12.618 2.57104 11.619 2.08704 10.45C1.60304 9.28 1.47604 7.993 1.72304 6.751C1.97004 5.51 2.57904 4.37 3.47504 3.474C4.37104 2.578 5.51004 1.97 6.75104 1.723C7.99304 1.476 9.28004 1.602 10.45 2.087C11.619 2.571 12.618 3.392 13.321 4.444C14.025 5.497 14.4 6.734 14.4 8C14.4 9.697 13.726 11.325 12.526 12.526Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillrule: "evenodd",
    cliprule: "evenodd",
    d: "M8.0002 5.6C8.4422 5.6 8.8002 5.242 8.8002 4.8C8.8002 4.358 8.4422 4 8.0002 4C7.5592 4 7.2002 4.358 7.2002 4.8C7.2002 5.242 7.5592 5.6 8.0002 5.6Z",
    fill: "#D72027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillrule: "evenodd",
    cliprule: "evenodd",
    d: "M8.0002 6.40002C7.7882 6.40002 7.5842 6.48402 7.4342 6.63402C7.2842 6.78402 7.2002 6.98802 7.2002 7.20002V11.2C7.2002 11.412 7.2842 11.616 7.4342 11.766C7.5842 11.916 7.7882 12 8.0002 12C8.2122 12 8.4162 11.916 8.5662 11.766C8.7162 11.616 8.8002 11.412 8.8002 11.2V7.20002C8.8002 6.98802 8.7162 6.78402 8.5662 6.63402C8.4162 6.48402 8.2122 6.40002 8.0002 6.40002Z",
    fill: "#D72027"
  })));
};

export default __webpack_public_path__ + "static/media/TooltipIcon.96fed506.svg";
export { SvgComponent as ReactComponent };